export default "__VITE_ASSET__0b08cffa__"